var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { DEFAULT_CHUNK_SIZE } from '../upload';
export function normalizeUploadConfig(config, logger) {
  var _a = __assign({}, config),
      upprotocol = _a.upprotocol,
      uphost = _a.uphost,
      otherConfig = __rest(_a, ["upprotocol", "uphost"]);

  var normalizeConfig = __assign({
    bucketName: "",
    endpoint: "",
    region: "",
    uphost: [],
    retryCount: 3,
    checkByMD5: false,
    forceDirect: false,
    useCdnDomain: true,
    concurrentRequestLimit: 3,
    chunkSize: DEFAULT_CHUNK_SIZE,
    upprotocol: 'https',
    debugLogLevel: 'OFF',
    disableStatisticsReport: false
  }, otherConfig); // 兼容原来的 http: https: 的写法


  if (upprotocol) {
    normalizeConfig.upprotocol = upprotocol.replace(/:$/, '');
  }

  var hostList = [];
  return __assign(__assign({}, normalizeConfig), {
    uphost: hostList.filter(Boolean)
  });
}